// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__3zmyN","row":"styles_row__3k2iJ","head":"styles_head__3J9KX","card":"styles_card__fADCB","cardImage":"styles_cardImage__18fsm"};